<template>
    <div>
            <b-card-group columns>
                <b-card
                        :header="formatDate(event)"
                        header-tag="header"
                        footer-tag="footer"
                        v-for="(event, index) in events" v-bind:key="event.id" v-bind:index="index"
                >
                    <template v-slot:header>
                        <div>
                            <span class="text-center">{{formatDate(event)}}</span>

                            <b-img right rounded="circle" width="50" height="50" src="https://picsum.photos/125/125/?image=58"/>

                        </div>
                    </template>
                    <b-card-title>{{getPrice(event)}}
                        <b-icon-info-circle v-b-tooltip.hover title="Tooltip directive content"/></b-card-title>
                    <b-card-text>
                        <div>{{event.field.name}}</div>
                        <div>{{event.field.address}}</div>
                        <div>{{event.field.plz}} {{event.field.city}}</div>
                    </b-card-text>
                    <b-button-group v-if="userView">
                        <b-button v-if="!event.isUserParticipant" @click="registerFromEvent(event)" variant="info">Anmelden</b-button>
                        <b-dropdown v-if="event.isUserParticipant" variant="success" right text="Angemeldet">
                            <b-dropdown-item @click="unregisterFromEvent(event)" variant="danger">Abmelden</b-dropdown-item>
                        </b-dropdown>
                    </b-button-group>
                    <b-button-group v-if="!userView">
                      <b-button v-if="event.state.id === 1" @click="registerFromEvent(event)" variant="info">Akzeptieren</b-button>
                      <b-button v-if="event.state.id === 1" @click="unregisterFromEvent(event)" variant="danger">Ablehnen</b-button>
                      <b-dropdown v-if="event.state.id === 4" variant="success" right text="Suche läuft">
                        <b-dropdown-item @click="unregisterFromEvent(event)" variant="danger">Suche abbrechen</b-dropdown-item>
                      </b-dropdown>
                    </b-button-group>
                    <template v-slot:footer>
                        <p :class="getFooterClass(index)">{{getFooterText(index)}}</p>
                    </template>
                </b-card>
            </b-card-group>
         <!--   <div class="mt-3">
                <b-pagination size="lg" align="center" v-model="currentPage" :total-rows="rows" :per-page="limit" @input="updatePage(currentPage)"/>
            </div>-->
    </div>
</template>

<script>

    import {utilsService} from "@/services/utils.service";
    import {BIconInfoCircle} from "bootstrap-vue"
    import {eventService} from "@/services/event.service";

    export default {
        name: 'EventList',
        components: {
            BIconInfoCircle
        },
      props:{
          events: Array,
          userView: Boolean
      },
        data() {
            return {
                hover: [],
                currentPage: 1,
                limit: 5,
                rows: 0,
            }
        },
        created() {
        },
        methods: {
            updatePage(currentPage) {
                this.getEvents(true, this.limit, currentPage-1)
            },
            hovered(index) {
                console.log(index);
                this.hover[index] = true;
            },
            getFooterText(index) {
                const participants = this.events[index].participants;
                return `Anmeldungen: ${participants.current}/${participants.max} (Min. ${participants.min})`;
            },
            getFooterClass(index) {
                const participants = this.events[index].participants;
                if (participants.current < participants.min) {
                    return "text-warning"
                } else if (participants.current === participants.max) {
                    return "text-danger";
                }
                return "text-success"
            },
            formatDate(event) {
                let dateText = "";
                // need replace for backend date, because of mobile issues
                const date = new Date(event.timeStart.replace(/-/g,'/'));
                const untilDate = new Date(date.getTime() + event.duration.time * utilsService.getValueForTimeUnit(event.duration.unit));
                const startDateText = utilsService.getGermanDateText(date);
                if (utilsService.datesAreOnSameDay(date, untilDate)) {
                    dateText = `${startDateText} (${utilsService.getGermanDateTextTime(date)} - ${utilsService.getGermanDateTextTime(untilDate)})`;
                } else {
                    dateText = `${startDateText} ${utilsService.getGermanDateTextTime(date)} - ${utilsService.getGermanDateText(untilDate)} ${utilsService.getGermanDateTextTime(untilDate)}`;
                }
                return dateText;

            },
          unregisterFromEvent(event) {
            eventService.participateEvent(event.id, false).then(res => {
              if (res.code === 1) {
                if (this.userView) {
                  this.$root.$bvToast.toast("Erfolgreich von dem Event abgemeldet", {
                    title: "Erfolgreich Abgemeldet",
                    autoHideDelay: 5000,
                    variant: "success"
                  });

                  event.participants.current -= 1
                  event.isUserParticipant = false
                } else {
                  this.$root.$bvToast.toast("Event wurde Abgelehnt", {
                    title: "Erfolgreich Abgelehnt",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$parent.refreshData()
                }
              } else {
                if (this.userView) {
                  this.$root.$bvToast.toast("Es gab einen Fehler beim Abmelden", {
                    title: "Fehler beim Abmelden",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                } else {
                  this.$root.$bvToast.toast("Fehler beim beenden des Events", {
                    title: "Fehler beim Beenden",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                }
              }
            })
          },
          registerFromEvent(event) {
            eventService.participateEvent(event.id, true).then(res => {
              if (res.code === 1) {
                if (this.userView) {
                  this.$root.$bvToast.toast("Erfolgreich an dem Event teilgenommen", {
                    title: "Erfolgreich Teilgenommen",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  event.participants.current += 1
                  event.isUserParticipant = true
                } else {
                  this.$root.$bvToast.toast("Erfolgreich das Event Akzeptiert", {
                    title: "Erfolgreich Akzeptiert",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$parent.refreshData()
                }
              } else {
                if (this.userView) {
                  this.$root.$bvToast.toast("Es gab einen Fehler beim Anmelden", {
                    title: "Fehler beim Anmelden",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                } else {
                  this.$root.$bvToast.toast("Es gab einen Fehler beim Akzeptieren", {
                    title: "Fehler beim Akzeptieren",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                }
              }
            })
          },
          getPrice(event) {
            const total = event.total.value;
            const max = event.maxPricePerPerson.value;
            let current;
            if (event.participants.current !== event.participants.max) {
              current = total / (event.participants.current + 1);
            } else {
              current = total / (event.participants.current);
            }
            if (current > max) {
              current = max;
            }
            return utilsService.formatCurrency(current) + " (Max. " + utilsService.formatCurrency(max) + ")";
          }
        }
    }
</script>

<style scoped>
    .list-group {
        width: 340px;
        margin: 50px auto;
    }
</style>
